import axios from 'axios';
import { platformClientHeaders } from './platform-client-headers';

export class PublicSharedApiService {
  constructor(private readonly endpoint: string) {}

  private absoluteUrl(path: string): string {
    const base = this.endpoint.endsWith('/') ? this.endpoint : `${this.endpoint}/`;
    return `${base}${path}`;
  }

  public async get<ResponseType>(options: { path: string }): Promise<ResponseType> {
    const { data } = await axios.get<ResponseType>(this.absoluteUrl(options.path), {
      headers: platformClientHeaders,
    });
    return data;
  }

  public async create<ResponseType>(options: {
    path: string;
    body: object;
  }): Promise<ResponseType> {
    const { data } = await axios.post<ResponseType>(this.absoluteUrl(options.path), options.body, {
      headers: {
        ...platformClientHeaders,
        'Content-Type': 'application/json',
      },
    });
    return data;
  }

  public async createGetWithoutResponseBody(options: { path: string }): Promise<void> {
    await axios.get(this.absoluteUrl(options.path), {
      headers: {
        ...platformClientHeaders,
        'Content-Type': 'application/json',
      },
    });
  }
}
